export default "__VITE_ASSET__6db82dae__"